import { useMutation } from 'react-query';
import { AuthService } from '../services';

export const useSendRegistrationInvite = () =>
  useMutation((email) => AuthService.sendRegistrationInvite(email));
